import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({providedIn: 'root'})
export class isQassatlyMerchantGuard implements CanActivate {
  constructor(private actionServ:ActionsService,private router:Router,private authServ:AuthService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
     if(this.actionServ.isQasstlyMerchant()) return true;
    this.router.navigate(['/']);
    return false;
  }
}
